import { PERMISSIONS } from '../../constants/permissions.constants';
import { hasPermission, hasPermissions } from '../../selectors/auth.selectors';

const canChangeStatus = (user) =>
  hasPermissions(user?.permissions, [
    PERMISSIONS.STAD_DISPATCH,
    PERMISSIONS.STAD_ADMIN,
    PERMISSIONS.PARTNER_ADMIN,
    PERMISSIONS.PARTNER_MEDEWERKER
  ]);

const canChangeDeadline = (user) =>
  hasPermissions(user?.permissions, [
    PERMISSIONS.STAD_DISPATCH,
    PERMISSIONS.STAD_ADMIN,
    PERMISSIONS.PARTNER_ADMIN,
    PERMISSIONS.PARTNER_MEDEWERKER,
    PERMISSIONS.PARTNER_NIET_FREQUENT
  ]);

const canAssignPeople = (user) =>
  hasPermissions(user?.permissions, [PERMISSIONS.STAD_DISPATCH, PERMISSIONS.STAD_ADMIN, PERMISSIONS.PARTNER_ADMIN]);

const canSetPrivateMode = (user) => hasPermission(user, PERMISSIONS.STAD_DISPATCH);

const dossierHeaderPermissionsService = {
  canChangeStatus,
  canChangeDeadline,
  canAssignPeople,
  canSetPrivateMode
};

export default dossierHeaderPermissionsService;
